import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all shards
 */
export function getShard(callback) {

    database.ref('shard').once('value')
        .then((snapshot) => {
            const shard = snapshot.val();
            callback(true, shard, null);
        });
}

export function setShard(data, callback) {
  database.ref('shard').set(data, function(error) {
      if (error) {
          callback(false, null, error);
      } else {
          callback(true, data, null);
      }
  })
}

/**
 * Create new shard
 */
export function createNewShard (data, callback) {
    //var newId = database.ref().child('shard').push().key;
    //data["id"] = newId;
    var newId = data.id;

    database.ref('shard/' + newId).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Edit shard
 */
export function editShard (id, data, callback) {
    database.ref('shard/' + id).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Delete Shard
 */
export function deleteShard(id, callback) {
    database.ref('shard').child(id).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}
